import React, {memo} from "react";
import styles from "./Divider.module.scss";

export default memo(function Divider({children, className = "", ...rest}) {
  if (children) {
    return (
      <div className={`d-flex align-items-center ${className}`} {...rest}>
        <div className="col">
          <hr className={`${styles.divider}`} />
        </div>
        <span className={`col-auto px-2 ${styles.children} fw-normal`}>{children}</span>
        <div className="col">
          <hr className={`${styles.divider}`} />
        </div>
      </div>
    );
  }

  return <hr className={`${styles.divider} ${className}`} {...rest} />;
});
